<template>
  <div class="dialog-wrap">
    <el-dialog
      title="文章资询"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="handleClose"
      width="480px"
    >
      <el-form
        class="form"
        :model="dataForm"
        :rules="rules"
        ref="dataForm"
      >
        <el-form-item label="标签：">
          <el-tag
            :key="tag"
            v-for="tag in keywordsTags"
            closable
            :disable-transitions="false"
            @close="handleToRemove(tag,'keywordsTags')"
          >
            {{tag}}
          </el-tag>
          <el-input
            class="input-new-tag"
            v-if="keywordsTagsVisible"
            v-model="keywordsTagsValue"
            ref="keywordsTags"
            @keyup.enter.native="handleKeywordsTagsConfirm"
            @blur="handleKeywordsTagsConfirm"
          ></el-input>
          <el-button
            v-else
            class="button-new-tag"
            size="small"
            @click="showKeywordsTagsVisible"
          >添加标签</el-button>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="handleClose">取 消</el-button>
        <el-button
          type="primary"
          @click="handleSubmit"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { articleUpdate, } from '@/api/article'


export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    content: {
      type: Object,
      default: () => { return {} }
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      dataForm: this.content || {},
      rules: {

      },
      keywordsTags: [],// 关键词标签数组
      keywordsTagsVisible: false,
      keywordsTagsValue: '',
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    content(val) {
      this.dataForm = val
      if (val.tags_real) {
        this.keywordsTags = val.tags_real.split(',')
      }
    }
  },
  methods: {
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const params = {
            id: this.dataForm.id,
            tags_real: this.keywordsTags.length ? this.keywordsTags.join(',') : "",
          }
          articleUpdate(params).then(res => {
            this.$message.success(`更新成功`)
            this.$refs['dataForm'].resetFields()

            this.$emit('submit')
            this.handleClose()
          }).catch(error => {
            console.log('error: ', error)
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleClose() {
      this.keywordsTags = []
      this.$emit('close')
    },
    handleKeywordsTagsConfirm() {
      let inputValue = this.keywordsTagsValue;
      if (inputValue) {
        this.keywordsTags.push(inputValue);
      }
      this.keywordsTagsVisible = false;
      this.keywordsTagsValue = '';
    },
    showKeywordsTagsVisible() {
      this.keywordsTagsVisible = true;
      this.$nextTick(_ => {
        this.$refs.keywordsTags.$refs.input.focus();
      });
    },
    handleToRemove(tag, name) {
      this.keywordsTags.splice(this.keywordsTags.indexOf(tag), 1);
    },
  }
}
</script>

<style lang="less" scoped>
.dialog-wrap {
  .form {
    margin-bottom: -18px;
  }
}
.input-new-tag {
  width: 90px;
}
.el-tag {
  line-height: 32px;
  height: 32px;
  margin: 0px 5px;
}
</style>
